import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const readPreview = () => {
  try {
    const raw = sessionStorage.getItem("dwg_view_as");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dwg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // ---- Role Preview guard: block ALL mutating requests while preview aktif ----
  // Backend RBAC tetap authoritative. Preview state disimpan di sessionStorage
  // (bukan cookie/JWT), jadi backend tidak pernah melihat "preview".
  const preview = readPreview();
  if (preview) {
    const method = String(config.method || "get").toLowerCase();
    const isMutation = ["post", "put", "patch", "delete"].includes(method);
    if (isMutation) {
      toast.error("Keluar dari Preview untuk melakukan aksi", { id: "preview-blocked" });
      return Promise.reject({
        __preview_blocked: true,
        message: "Aksi ditolak: sedang dalam Preview peran",
        config,
      });
    }
    // Mark GET/HEAD dengan flag supaya response interceptor bisa treat 400/403
    // sebagai "backend melihat Owner, bukan role preview" — bukan error asli.
    config.__preview_active = true;
  }
  return config;
});

// Response interceptor — saat Preview aktif, backend permission mismatch (400/403)
// wajar terjadi (mis. Staf Divisi memanggil /my/workspace, backend tetap lihat Owner
// tanpa division_id). Tag error jadi __preview_backend_mismatch supaya komponen bisa
// render empty state yang sopan, dan lempar warning ringan ke console (bukan overlay).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.config?.__preview_active) {
      const status = err?.response?.status;
      if (status === 400 || status === 403 || status === 404) {
        err.__preview_backend_mismatch = true;
        // Silent — komponen yang panggil harus punya .catch untuk render empty state.
      }
    }
    return Promise.reject(err);
  },
);
